export const SCHEDULING_INTERVIEW_DETAILS = 'scheduling/fetch';
export const SCHEDULING_EVENT_ID = 'scheduling/EVENT/fetch';
export const SCHEDULING_INTERVIEWERS_EVENT = 'scheduling/interviewer/fetch';
export const FETCH_INTERVIEWERS_LIST = 'scheduling/interviewersList/fetch';
export const SUGGESTED_INTERVIEW_ID = 'scheduling/INTERVIEW-ID/fetch';
export const CREATED_INTERVIEW = 'scheduling/createdInterview/fetch';
export const SCHEDULED_INTERVIEW = 'scheduling/scheduledInterview/fetch';
